import { IUpdateSalePlanningIndexItem } from 'interfaces/SaleLine';
import {
  ICreateSalePlanningAuto,
  IUpdateSalePlanning,
} from 'interfaces/SalePlanning';
import { convertDateToBE } from 'utils/constants/functions';

export interface IParams {
  teamSalesId?: string;
  plantId?: string;
  routeId?: string;
  statusId?: string;
  toDate?: string;
  fromDate?: string;
  page: number;
  page_size: number;
  columns?: any;
  title?: string;
}

export interface IExportSalePlan {
  teamSalesId?: string;
  plantId?: string;
  routeId?: string;
  statusId?: string;
  toDate?: string;
  fromDate?: string;
  teamCapacity?: string;
}

export interface ICreateSalePlanning {
  name: string;
  plantId: string;
  expectedRevenue: string;
  implementationDate: string;
  routeId: string;
  teamSalesId: string;
  unitMoney: string;
  implementationEndDate: string;
}

export interface ICheckExistSalePlan {
  plantId: string;
  teamSalesId: string;
  implementationDate: string;
}

export interface ICheckCreateSalePlan {
  routeId?: string;
  teamSalesId?: string;
  plantId?: string;
  implementationDate?: string;
  implementationEndDate?: string;
  salePlanningId?: string;
}

// update many  sale planning customer revenue
export interface IUpdateManySalePlanningCustomerRevenue {
  id: string;
  averageRevenue: string;
}

export const SALE_PLAN_VARIABLE = {
  getSalePlan: (params: any) => {
    const {
      teamSalesId,
      plantId,
      routeId,
      statusId,
      toDate,
      fromDate,
      teamCapacity,
      page,
      page_size,
    } = params;
    return {
      skip: (page - 1) * page_size,
      take: page_size,
      input: {
        ...(teamSalesId && { teamId: { equals: teamSalesId } }),
        ...(plantId && { plantId: { equals: plantId } }),
        ...(routeId && { routeId: { equals: routeId } }),
        ...(statusId && { statusId: { equals: statusId } }),
        ...((toDate || fromDate) && {
          implementationDate: {
            ...(fromDate && { gte: convertDateToBE(fromDate) }),
            ...(toDate && { lte: convertDateToBE(toDate) }),
          },
        }),
        ...(teamCapacity && { teamCapacity: { contains: teamCapacity } }),
      },
    };
  },
  getSalePlanNew: (params: any) => {
    const {
      teamSalesId,
      plantId,
      routeId,
      statusId,
      toDate,
      fromDate,
      teamCapacity,
      page,
      page_size,
    } = params;

    return {
      skip: (page - 1) * page_size,
      take: page_size,
      input: {
        ...(teamSalesId && { teamId: teamSalesId }),
        ...(plantId && { plantId: plantId }),
        ...(routeId && { routeId: routeId }),
        ...(statusId && { statusId: statusId }),
        ...(toDate && {
          implementationDateTo: toDate,
        }),
        ...(fromDate && {
          implementationDateFrom: fromDate,
        }),
        ...(teamCapacity && { teamCapacity }),
      },
    };
  },
  exportSalePlan: (params: IExportSalePlan) => {
    const {
      teamSalesId,
      plantId,
      routeId,
      statusId,
      toDate,
      fromDate,
      teamCapacity,
    } = params;

    return {
      input: {
        ...(teamSalesId && { teamId: teamSalesId }),
        ...(plantId && { plantId: plantId }),
        ...(routeId && { routeId: routeId }),
        ...(statusId && { statusId: statusId }),
        ...(toDate && {
          implementationDateTo: toDate,
        }),
        ...(fromDate && {
          implementationDateFrom: fromDate,
        }),
        ...(teamCapacity && { teamCapacity }),
      },
    };
  },
  getCustomerById: (params: any) => {
    const { branchid } = params;
    return {
      input: {
        branchId: {
          equals: branchid,
        },
      },
    };
  },
  searchNotCustomSalePlan: ({
    custId,
    salesPlanningId,
    skip = 0,
    take = 20,
  }: {
    salesPlanningId: any;
    custId: any;
    skip?: number;
    take?: number;
  }) => {
    return {
      skip,
      take,
      input: {
        custId,
        salesPlanningId,
      },
    };
  },
  updateSalePlanning: (params: IUpdateSalePlanning) => {
    return {
      input: {
        ...params,
        genarateYn: true,
      },
    };
  },
  updateSalePlanningIndex: (param: IUpdateSalePlanningIndexItem[]) => {
    return {
      input: param,
    };
  },
  createSalePlanning: (params: ICreateSalePlanning) => {
    return {
      input: {
        ...params,
        genarateYn: true,
      },
    };
  },
  checkExistSalePlan: ({
    implementationDate,
    plantId,
    teamSalesId,
  }: ICheckExistSalePlan) => {
    return {
      input: {
        plantId: { equals: plantId },
        teamSalesId: { equals: teamSalesId },
        implementationDate: { equals: implementationDate },
      },
    };
  },
  checkCreateSalePlanning: ({
    implementationDate,
    implementationEndDate,
    plantId,
    routeId,
    teamSalesId,
    salePlanningId,
  }: ICheckCreateSalePlan) => {
    return {
      input: {
        ...(routeId && { routeId }),
        ...(teamSalesId && { teamSalesId }),
        ...(plantId && { plantId }),
        ...(implementationDate && {
          implementationDate,
        }),
        ...(implementationEndDate && {
          implementationEndDate,
        }),
        ...(salePlanningId && { salePlanningId }),
      },
    };
  },
  // update many  sale planning customer revenue
  updateManySalePlanningCustomerRevenue: (
    params: IUpdateManySalePlanningCustomerRevenue[],
  ) => {
    return {
      input: params,
    };
  },
};

export const VARIABLE_ADD_CUSTOM_SALEPLAN = (params: any) => {
  const { salesPlanningId, listCustomer } = params;
  if (listCustomer.length == 0)
    return {
      input: [],
    };
  return {
    input: listCustomer.map((item: any) => {
      return {
        salesPlanningId: salesPlanningId,
        customerId: item.id,
        indexNum: null,
      };
    }),
  };
};

export const VARIABLE_GET_DASHBORAD_TEAMSALE = (params: {
  teamSalesId: any;
  gt: any;
  lt: any;
}) => {
  const { teamSalesId, gt, lt } = params;
  return {
    input: {
      teamId: teamSalesId,
      implementationDateFrom: gt,
      implementationDateTo: lt,
    },
  };
};

export const VARIABLE_CREATE_DASHBOARD_TEAM_SALE = (
  params: ICreateSalePlanningAuto,
) => {
  const { team_id, month, year, plantId } = params;
  return {
    input: {
      team_id,
      month,
      year,
      plant_id: plantId,
    },
  };
};
